import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-log-out",
  "use": "icon-log-out-usage",
  "viewBox": "0 0 24 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 20\" id=\"icon-log-out\"><path d=\"M16 7V3l8 7-8 7v-4H8V7zM0 0v20h14v-2H2V2h12V0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol